import React from "react";
import { Button, IconButton } from '@workboard/wobo-ui';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import AddIcon from '@material-ui/icons/AddCircleOutline';
import HelpOutline from "@material-ui/icons/HelpOutline";
import GoalServices from "./../../../../services/goal.services";
import SearchBoxComp from "../../../inputs/searchbox.component";
import { RollUpKrSearchTableComp, RollUpTableComp } from "./rolluptable.component";
import { ClosedKrLockContext } from '../closedKrLock.context';

const StyledIconButton = styled(IconButton)`
  width: 16px;
  height: 16px;
  svg {
    width: 14px;
    height: 14px;
  }
`;

const ALIGN_KR = "allign_kr";
export class KrAlignDependance extends React.Component {
	static contextType = ClosedKrLockContext;

	constructor (props){
		super(props);
		this.state = {
			filter:{
				krAlign: [],
				krDepend:[]
			},
			enableAlign: false,
			headAlignDendance: ( (this.props.krAlingArr && this.props.krAlingArr !== undefined && this.props.krAlingArr.length > 0 ) 
								|| (this.props.krDependenciesArr && this.props.krDependenciesArr !== undefined && this.props.krDependenciesArr.length > 0 ) )
								? false : true,
			alignsKrHelpPopUp: false,
			krAlignmentEn: false,
			krAlingSelected: this.props.krAlingArr &&
							 this.props.krAlingArr !== undefined &&
							 this.props.krAlingArr.length > 0
							  ? this.props.krAlingArr
							  : [],
			depedenciesKrHelpPopUp: false,
			dependenciesKrSelected: this.props.krDependenciesArr &&
									this.props.krDependenciesArr !== undefined &&
									this.props.krDependenciesArr.length > 0
									  ? this.props.krDependenciesArr
									  : [],
			krDependenciedEn:false,
		}
		this.GoalServices = new GoalServices();
		this.displayAlignDependance = this.displayAlignDependance.bind(this);
		this.handleKrDependecyChange = this.handleKrDependecyChange.bind(this);
		this.handleKrAlignChange = this.handleKrAlignChange.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.renderSearchKR = this.renderSearchKR.bind(this);
		this.krBeforeFilterValues = this.krBeforeFilterValues.bind(this);
		this.checkKRValue = this.checkKRValue.bind(this);
		this.checkKRValueAlign = this.checkKRValueAlign.bind(this);
		this.renderSearchKRAlign = this.renderSearchKRAlign.bind(this);
		this.krBeforeFilterValuesAlign = this.krBeforeFilterValuesAlign.bind(this);
		this.removeKrAlign = this.removeKrAlign.bind(this);
		this.removeKrDependent = this.removeKrDependent.bind(this);

		this.mouseOverDependsHelpText = this.mouseOverDependsHelpText.bind(this);
		this.mouseLeaveDependsHelpText = this.mouseLeaveDependsHelpText.bind(this);
		this.mouseOverAlignsHelpText = this.mouseOverAlignsHelpText.bind(this);
		this.mouseLeaveAlignsHelpText = this.mouseLeaveAlignsHelpText.bind(this);

		this.dependsRef = React.createRef();
		this.alignsRef = React.createRef();
		const { t } = props;
		this.krAlignLabels = this.props.addOkrData.kr_relationship
		? {
			addKR: t('Align to other key results optional'),
			dependsOn: t('Key Results this result aligns to'),
			help: `${t('Search and select Key Results that align to your results.')} ${t('If another team aligns their Key Results to this result, it will also show in this list.')}`,
		}
		: {
			addKR: t('Add Key Results dependencies (optional)'),
			dependsOn: t('Key result(s) this result depends on'),
			help: t('Key result dependencies are a way to visualize how your key result may depend on outcomes from other lateral or vertical teams') +'.',
		};		
	}
	
	componentDidMount() {
		document.addEventListener("mousedown", this.handleClickOutside);
	}
	
	componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleClickOutside);
	}
	handleClickOutside(e){
		let that = this;
		let enableObj = {};
		let filterObj = {
		  filter: {}
		};
		if (
			!$(".objAlignment").is(e.target) &&
			$(".objAlignment").has(e.target).length === 0
		) {
			enableObj["krAlignmentEn"] = false;
			filterObj.filter["krAlign"] = [];
		}
		if (
			!$(".objDependencies").is(e.target) &&
			$(".objDependencies").has(e.target).length === 0
		) {
			enableObj["krDependenciedEn"] = false;
			filterObj.filter["krDepend"] = [];
		}
		if (Object.keys(enableObj).length && Object.keys(filterObj).length) {
		  this.setState({
			...enableObj,
			filter: { ...this.state.filter, ...filterObj.filter }
		  });
		}
	}
	
	displayAlignDependance(){
		this.setState({
			headAlignDendance: !this.state.headAlignDendance
		},()=>{
			const target = document.getElementById("kr-depends-on-search");
     		target && target.focus(); 
		}
		)
	}
		
	handleKrAlignChange(event, selectedGoal) {
		event.stopPropagation();
		let existingState = this.state.krAlingSelected;
		let result = [];

		if (existingState.find(val => val.id == selectedGoal.id)) {
		  result = existingState.filter(eachVal => eachVal.id != selectedGoal.id);
		} else {
		  result = [...existingState, selectedGoal];
		}
		this.setState({ krAlingSelected: result }, () => this.props.saveAlignArr(this.state.krAlingSelected) );
	}

	handleKrDependecyChange(event, selectedDependency) {
		event.stopPropagation();
		let existingState = this.state.dependenciesKrSelected;
		let result = [];
		if (existingState.find(val => val.id == selectedDependency.id)) {
		  result = existingState.filter(
			eachVal => eachVal.id != selectedDependency.id
		  );
		} else {
		  result = [...existingState, selectedDependency];
		}
		this.setState({ dependenciesKrSelected: result }, () => this.props.saveDependentArr(this.state.dependenciesKrSelected) );
	}

	renderSearchKR(values = [], inst = null) {
		let dependenciesKrSelected = this.state.dependenciesKrSelected;
		if (values.length) {
		  let attr = {};
		  let showCheckBox = true;
		  if (!showCheckBox) {
			attr.rowClick = this.clickKrItem;
		  } else {
			attr.checkedValues = dependenciesKrSelected.map(m => m.id);
			attr.checkBoxProps = {
			  onChange: this.checkKRValue,
			};
		  }

		  let dependenceListing = $('.dependenceListing').offset();
		  let dependenceTop = dependenceListing.top;
		  let dependenceSearchHeight = dependenceTop + 350 ;
		  return values.map(m => <RollUpKrSearchTableComp key={"search_key_" + m.id} value={m} attr={attr} inst={inst} /> );
		} else {
		  return null;
		}
	  }
	krBeforeFilterValues(values = []) {
		let dependenciesKrSelected = this.state.dependenciesKrSelected;
		if (Array.isArray(values) && values.length) {
			let editMetricId = '';
			if (this.props.item.id !== undefined && Object.keys(this.props.item.id).length) {
			editMetricId = this.props.item.id;
			}
			values = values.map((v) => {
				if (typeof v.metrics === 'undefined') {
					v.metrics = [];
				}
				else {
					v.metrics = v.metrics.filter(m => (editMetricId == '' || editMetricId != m.id));
				}
			return v;
			});
			values = values.filter(f => f.metrics.length);
		}
		return values;
	}
	checkKRValue(e, item) {
		let dependenciesKrSelected = this.state.dependenciesKrSelected;
		if (e.target.checked) {
		  let findKR = dependenciesKrSelected.find(k => k.id == item.id);
		  if (!findKR) {
			dependenciesKrSelected = [...dependenciesKrSelected, item];
		  }
		} else {
			dependenciesKrSelected = dependenciesKrSelected.filter(k => k.id != item.id);
		}
		this.setState({ dependenciesKrSelected }, () => this.props.saveDependentArr(this.state.dependenciesKrSelected) );
	}

	renderSearchKRAlign(values = [], inst = null) {
		let krAlingSelected = this.state.krAlingSelected;
		if (values.length) {
		  let attr = {};
		  let showCheckBox = true;
		  if (!showCheckBox) {
			attr.rowClick = this.clickKrItem;
		  } else {
			attr.checkedValues = krAlingSelected.map(m => m.id);
			attr.checkBoxProps = {
			  onChange: this.checkKRValueAlign,
			};
		  }
		  let alignListing = $('.alignListing').offset();
		  let alignTop = alignListing.top;
		  let alignSearchHeight = alignTop + 350 ;
		  let dependentListing = $('.dependentListing').height();		  
		  if(dependentListing > 0 ){
			alignSearchHeight = alignSearchHeight + dependentListing + 40 ;
		  }
		  return values.map(m => <RollUpKrSearchTableComp key={"search_key_" + m.id} value={m} attr={attr} inst={inst} /> );
		} else {
		  return null;
		}
	  }
	krBeforeFilterValuesAlign(values = []) {
		let krAlingSelected = this.state.krAlingSelected;
		if (Array.isArray(values) && values.length) {
			let editMetricId = '';
			if (this.props.item.id !== undefined && Object.keys(this.props.item.id).length) {
			editMetricId = this.props.item.id;
			}
			values = values.map((v) => {
				if (v.metrics) {
					v.metrics = v.metrics.filter(m => (editMetricId == '' || editMetricId != m.id));
				}
				return v;
			});
			values = values.filter(f => f.metrics.length);
		}
		return values;
	}
	checkKRValueAlign(e, item) {
		let krAlingSelected = this.state.krAlingSelected;
		if (e.target.checked) {
		  let findKR = krAlingSelected.find(k => k.id == item.id);
		  if (!findKR) {
			krAlingSelected = [...krAlingSelected, item];
		  }
		} else {
			krAlingSelected = krAlingSelected.filter(k => k.id != item.id);
		}
		this.setState({ krAlingSelected }, () => this.props.saveAlignArr(this.state.krAlingSelected) );
	}
	removeKrDependent(e, item){
		let dependenciesKrSelected = this.state.dependenciesKrSelected.filter(k => k.id != item.id);
		let updateObj = { dependenciesKrSelected };
		this.setState(updateObj, () => {
			this.props.saveDependentArr(dependenciesKrSelected)
			if(dependenciesKrSelected.length == 0) {
				document.getElementById("kr-depends-on-search")?.focus()
			} else {
				this.focusOnNextRemovableItem(".KR-this-result-depends-on");
			}
		});
	}
	removeKrAlign(e, item){
		let krAlingSelected = this.state.krAlingSelected.filter(k => k.id != item.id);
		let updateObj = { krAlingSelected };
		this.setState(updateObj, () => {
			this.props.saveAlignArr(krAlingSelected)
			if(krAlingSelected.length == 0) {
				document.getElementById("kr-dependent-search")?.focus()
			} else {
				this.focusOnNextRemovableItem(".KR-dependent-on-this-result");
			}
		});
	}

	focusOnNextRemovableItem(commonClass) {
		const focusableRemoveElements = document.querySelectorAll(commonClass);
		    const focusableRemoveArr = Array.prototype.slice.call(focusableRemoveElements);
		    const firstRemoveBtn = focusableRemoveArr[0];
				if (firstRemoveBtn) {
        		firstRemoveBtn?.focus();
      	}
	}

	mouseOverDependsHelpText(e) {
		this.setState({
			depedenciesKrHelpPopUp: true,
			alignsKrHelpPopUp: false
		});
	}

	mouseLeaveDependsHelpText(e) {
		if (this.dependsRef && this.dependsRef.current && this.dependsRef.current.contains(e.target)) {
			this.setState({
				depedenciesKrHelpPopUp: false,
				alignsKrHelpPopUp: false
			});
		}
	}

	mouseOverAlignsHelpText(e) {
		this.setState({
			depedenciesKrHelpPopUp: false,
			alignsKrHelpPopUp: true
		});
	}

	mouseLeaveAlignsHelpText(e) {
		if (this.alignsRef && this.alignsRef.current && this.alignsRef.current.contains(e.target)) {
			this.setState({
				depedenciesKrHelpPopUp: false,
				alignsKrHelpPopUp: false
			});
		}
	}

	handleHelpPopper = (e, popup) => {
		const showHidePopup = e.key === 'Enter' || e.key === ' ' || e.type === 'click';
		const closePopper = e.key === 'Escape' || (e.shiftKey && e.key === 'Tab');
		if(showHidePopup) {
			e.preventDefault();
			this.setState(prevState => ({
				depedenciesKrHelpPopUp: popup === 'depends' ? !prevState.depedenciesKrHelpPopUp : prevState.depedenciesKrHelpPopUp,
				alignsKrHelpPopUp: popup === 'aligns' ? !prevState.alignsKrHelpPopUp : prevState.alignsKrHelpPopUp
			}));
		} else if (closePopper) {
			e.stopPropagation();
			this.setState({
				depedenciesKrHelpPopUp: false,
				alignsKrHelpPopUp: false
			});
		}
	}
	handleHelpTabPopper = (e, id) => {
		if (e.key === "Tab") {
			e.stopPropagation();
			this.setState({
				depedenciesKrHelpPopUp: false,
				alignsKrHelpPopUp: false
			});
		  } else if (e.key === "Escape") {
			e.stopPropagation();
			this.setState({
				depedenciesKrHelpPopUp: false,
				alignsKrHelpPopUp: false
			});
			setTimeout(() => {
			  document.getElementById(id).focus();
			});
		  }
	}
	render() {
		// check feature flag and remove itself.
		const isKRRelationshipEnabled = wbConfig.isKRRelationshipEnabled || false;
		const isClosedKr = this.context;
		if (isKRRelationshipEnabled || (isClosedKr && this.state.headAlignDendance)) {
			return <></>;
		}

		let Aligns = this.state.krAlingSelected;
		let dependents = this.state.dependenciesKrSelected;
		let { start_date = 'new', target_date = 'new' } = this.props.goalDetails;
		let krUrl = `goal/searchKrs?type=kr&goal_start=${start_date}&goal_end=${target_date}&notInclude=true`;
		const { t } = this.props;
		return (
			<React.Fragment>
			{
				this.state.headAlignDendance && (
	              	<div className="aEOptionDescSec" data-testid="aEOptionDescSec" style = {{display :'flex'}}>
						<div tabIndex={0}>
							<span>
								<AddIcon style={{ color: '#596373', padding: '3px', fontWeight: 700, margin: '-6px 0px 0px 0px', width: '18px' }} onClick={this.displayAlignDependance}
								/>
							</span>
						</div>
		                <div className="inLineBlk divWidth100">
							{/* <ThemeProvider> */}
							<Button className="krAlign-label" variant="ghost" style = {{ padding:'4px' }} onClick={this.displayAlignDependance}>{this.krAlignLabels.addKR}</Button>
							{/* </ThemeProvider> */}
		                </div>
	              	</div>
	            )
            }

			{ 
				!this.state.headAlignDendance && (
					<React.Fragment>
					<div className="fieldcontent">
						<div className="wherekrDataCome">
							{this.krAlignLabels.dependsOn}
							<div className="krAlignHelpContainer" 
								ref={this.dependsRef}
								onMouseEnter={event => this.mouseOverDependsHelpText(event)}
								onMouseLeave={event => this.mouseLeaveDependsHelpText(event)}
							>
								<StyledIconButton
									aria-describedby='aligns-help-label aligns-help-tooltip'
									aria-label={t('Help')}
									onClick={event => this.handleHelpPopper(event, 'depends')}
									onKeyDown={event => this.handleHelpPopper(event, 'depends')}
									id="singlekr-depends-tooltip-id"
								>
									 <HelpOutline />
								</StyledIconButton>
								{ this.state.depedenciesKrHelpPopUp && 
								( <div className="form-popup pos-help-popup" id='aligns-help-tooltip'
									onKeyDown={(e) => {
										this.handleHelpTabPopper(e, "singlekr-depends-tooltip-id")
									}}>
											{this.krAlignLabels.help}
										<a className="learnmore linkUnderline" style={{marginLeft: '5px'}} target="_blank" href="https://workboard.zendesk.com/hc/en-us/articles/360038736732">
											{t('Learn more')}
										</a>
									</div>
								)}
							</div>
						</div>
						{!isClosedKr && <div>
							<SearchBoxComp
								key="kr-box"
								minLength="2"
								wrapperClass="rollup-kr-box dependenceListing"
								url={
									krUrl
								}
								inputProps={{
									placeholder:
									t('Search for a person, team, or key result')
								}}
								renderResultComp={this.renderSearchKR}
								beforeFilterValues={this.krBeforeFilterValues}
								type={ALIGN_KR}
								searchBoxId='kr-depends-on-search'
							/>
						</div>}
						
					</div>
					<div className="fieldcontent dependentListing">
						{dependents.length > 0 && (
							<div className="wherekrDataCome">{t('Selected key result')}(s):</div>
						)}
						{dependents.map(r => (
							<RollUpTableComp
								key={"rollup_metric_" + r.id}
								type="kr"
								tableClass="rollup-kr-table"
								row={r}
								removeItem={isClosedKr ? false : this.removeKrDependent}
								searchKR={false}
								addClass="KR-this-result-depends-on"
							/>
						))}
						{this.props.addOkrData.kr_relationship > 0 && (
							Aligns.map(r => (
								<RollUpTableComp
									key={"rollup_metric_" + r.id}
									type="kr"
									tableClass="rollup-kr-table"
									row={r}
									removeItem={isClosedKr ? false : this.removeKrAlign}
									searchKR={false}
								/>
							))
						)}
					</div>
					</React.Fragment>
				)
			}

			{ 
				!this.state.headAlignDendance && !this.props.addOkrData.kr_relationship && (
					<React.Fragment>
						<div className="fieldcontent">
							<div className="wherekrDataCome">
								{t('Key result')}(s) {t('dependent on this result')}
								<div className="krAlignHelpContainer"
									onMouseEnter={event => this.mouseOverAlignsHelpText(event)}
									onMouseLeave={event => this.mouseLeaveAlignsHelpText(event)}
									ref={this.alignsRef}
								>
									<StyledIconButton
										aria-describedby='depends-help-tooltip'
										aria-label={t('Help')}
										onClick={event => this.handleHelpPopper(event, 'aligns')}
										onKeyDown={event => this.handleHelpPopper(event, 'aligns')}
										id="depends-help-tooltip-id"
									>
										<HelpOutline />
									</StyledIconButton>
									{
										this.state.alignsKrHelpPopUp && (
											<div className="form-popup pos-help-popup" id='depends-help-tooltip'
												onKeyDown={(e) => {
													this.handleHelpTabPopper(e, "depends-help-tooltip-id")
												}}>
												<b>{t('FROM')+ ':'}</b> {t('You can also align your key result to a result that is dependent on your outcome! You will be able to see these relationships from the Alignment tree on Key Result pages')}.
												<a className="learnmore linkUnderline" style={{marginLeft: '5px'}} target="_blank" href="https://workboard.zendesk.com/hc/en-us/articles/360038736732">
												 {t('Learn more')}
												</a>
											</div>
										)
									}
								</div>
							</div>
							{!isClosedKr && <div>
								<SearchBoxComp
									key="kr-box"
									minLength="2"
									wrapperClass="rollup-kr-box alignListing"
									url={
										krUrl
									}
									inputProps={{
										placeholder:
										t('Search for a person, team, or key result')
									}}
									renderResultComp={this.renderSearchKRAlign}
									beforeFilterValues={this.krBeforeFilterValuesAlign}
									type={ALIGN_KR}
									searchBoxId='kr-dependent-search'

								/>
							</div>}
							
						</div>
						<div className="fieldcontent">
							{Aligns.length > 0 && (
								<div className="wherekrDataCome">{t('Selected key result')}(s):</div>
							)}
							{Aligns.map(r => (
								<RollUpTableComp
									key={"rollup_metric_" + r.id}
									type="kr"
									tableClass="rollup-kr-table"
									row={r}
									removeItem={isClosedKr ? false : this.removeKrAlign}
									searchKR={false}
									addClass="KR-dependent-on-this-result"
								/>
							))}
						</div>
					</React.Fragment>
				)
			}
			{!this.state.headAlignDendance && <div className="krBreak" aria-hidden="true" />}
			
           </React.Fragment>
		);
	}

} 

export default withTranslation()(KrAlignDependance)